var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCourseintrostars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 31,
    viewBox: "0 0 176 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m16.5 0 3.895 11.84H33L22.802 19.16 26.698 31 16.5 23.682 6.302 31l3.896-11.841L0 11.841h12.605L16.5 0zM52.5 0l3.895 11.84H69L58.803 19.16 62.698 31 52.5 23.682 42.302 31l3.896-11.841L36 11.841h12.605L52.5 0zM88 0l3.777 11.84H104l-9.888 7.319L97.889 31 88 23.682 78.112 31l3.777-11.841L72 11.841h12.223L88 0zM123.5 0l3.895 11.84H140l-10.197 7.319L133.698 31 123.5 23.682 113.302 31l3.896-11.841L107 11.841h12.605L123.5 0zM159.5 0l3.895 11.84H176l-10.197 7.319L169.698 31 159.5 23.682 149.302 31l3.896-11.841L143 11.841h12.605L159.5 0z",
    fill: "#F2C94C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseintrostars);
export default __webpack_public_path__ + "static/media/Course intro stars.7600ee6129921a0559c6d980c4db2f6b.svg";
export { ForwardRef as ReactComponent };